import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAscIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M3 15V13H9V15H3ZM3 10V8H15V10H3ZM3 5V3H21V5H3Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M21 17L17 21L13 17L14.4 15.6L16 17.2V13H18V17.2L19.6 15.6L21 17Z",
		fill: "currentColor"
	})]
});
export default SvgAscIcon;
